import { Heading } from '@chakra-ui/react';
import React from 'react';

interface WelcomeHeadingProps {
  children: React.ReactNode;
  fadeDelay?: number;
}

export const WelcomeHeading: React.FC<WelcomeHeadingProps> = ({ children, fadeDelay = 0 }) => {
  const fadeInAnimation = {
    '@keyframes fadeIn': {
      from: {
        opacity: 0,
        transform: 'translateY(10px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
    animation: `fadeIn 0.5s ease-out ${fadeDelay}s both`,
  };

  return (
    <Heading
      as="h1"
      size={{ base: '2xl', md: '3xl', lg: '4xl' }}
      fontWeight="semibold"
      textAlign="center"
      color="dark"
      fontFamily="display"
      css={fadeDelay > 0 ? fadeInAnimation : undefined}
    >
      {children}
    </Heading>
  );
};
